module.exports = __webpack_public_path__ + "img/slide3.2d644699.svg";